import { render, staticRenderFns } from "./SignOutButton.vue?vue&type=template&id=2e7f8b97&scoped=true&"
import script from "./SignOutButton.vue?vue&type=script&lang=js&"
export * from "./SignOutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f8b97",
  null
  
)

export default component.exports